export default __webpack_public_path__ + "static/article-whats-your-dog-interest-rate-1402860f617e4414663ae5a14cdf308c.jpg";